import { gql } from "@apollo/client"

export const Logout = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      errors
    }
  }
`

export const Account = gql`
  query Account {
    me {
      emailAddress
      verified
    }
  }
`

export const RsvpPortal = gql`
  query RsvpPortal($id: ID!) {
    rsvpPortal(id: $id) {
      hashid
      reserveParkingSpotText
      reserveNewCodeText
      reserveExistingCodeText
      manageParkingText
    }
  }
`
